import _ from 'lodash';

export const getCustomerProfileResetUsenameOrPasswordConfig = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.resetUsenameOrPasswordLabels`,
  );
};

export const getCustomerProfileResetUsenameConfig = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.resetUsenameOrPasswordLabels.usename`,
    {},
  );
};

export const getCustomerProfileResetPasswordConfig = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.resetUsenameOrPasswordLabels.password`,
    {},
  );
};

export const getCustomerProfileCurrentUpdateKey = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.customerResetUNOrPW.curUpdateKey`,
    '',
  );
};
